import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledDropDown, StyledDropDownWrapper } from './DropDownStyles';

export const DropDown = React.memo(({ children, content, height, isDefaultExpanded }) => {
  const [isExpanded, setIsExpanded] = useState(isDefaultExpanded);

  return (
    <StyledDropDown>
      {children(isExpanded, () => setIsExpanded(!isExpanded))}
      <StyledDropDownWrapper wrapperHeight={height} isExpanded={isExpanded}>
        {content}
      </StyledDropDownWrapper>
    </StyledDropDown>
  );
});

DropDown.propTypes = {
  children: PropTypes.func.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  height: PropTypes.number,
  isDefaultExpanded: PropTypes.bool,
};

DropDown.defaultProps = {
  height: 100,
  isDefaultExpanded: false,
};
